export const _51z = { // 履歴対象・ドメイン個別
  _51r: { // 設定値
    v0: {
      itlz: {
        _51r_31r1f: -1,
        _51ra1100t: null
      },
      fldz: {
        _51r_31r1f: {
          pfx: '部門',
        },
        _icn: {
          pfx: '設定項目ID',
        },
        _51ra1100t: {
          pfx: '設定値',
        },
      },
    },
  },
};
